import { render, staticRenderFns } from "./AccountDisplay.vue?vue&type=template&id=4ed8d2e7"
import script from "./AccountDisplay.vue?vue&type=script&lang=js"
export * from "./AccountDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports